// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"e0858b42","453":"6cb71684","577":"1d7b2808"}[chunkId] + ".chunk.js";
};